import type { Frame, FrameTags } from "@/types/dragon-tiles";

export function isFrameInEventSequence(
  frame: Pick<Frame, "metadata">,
  eventId: string,
): boolean {
  return frame.metadata?.part != null && isFrameLinkedToEvent(frame, eventId);
}

export type FrameEventMetadata = NonNullable<FrameTags["events"]>[number];

function getFrameEvents(metadata: FrameTags): FrameEventMetadata[] {
  return metadata.events ?? [];
}

export function getActiveFrameEventId(
  metadata: FrameTags | undefined,
): string | undefined {
  return metadata
    ? getFrameEvents(metadata).find((eventItem) => eventItem.active === 1)?.name
    : undefined;
}

export function isFrameLinkedToEvent(
  frame: Pick<Frame, "metadata">,
  eventId: string,
): boolean {
  const events = getFrameEvents(frame.metadata ?? {});
  return events.some(
    (eventItem) => eventItem.name === eventId && eventItem.active === 1,
  );
}

export function buildClonedEventSequenceMetadata(
  sequenceMetadata: FrameTags,
  eventId: string,
): FrameTags {
  return buildFrameMetadataWithSelectedEvent(
    { ...sequenceMetadata, events: undefined },
    eventId,
  );
}

export function buildFrameMetadataWithSelectedEvent(
  existingMetadata: FrameTags,
  eventId: string,
): FrameTags {
  const existingEvents = getFrameEvents(existingMetadata).filter(
    (eventItem) => eventItem.name !== eventId,
  );

  return {
    ...existingMetadata,
    events: [...existingEvents, { name: eventId, active: 1 }],
  };
}
